import { createContext } from 'react'

export type ColorScheme = 'light' | 'dark'

export interface DarkModeContextType {
    colorScheme: ColorScheme
    toggleColorScheme: () => void
    setColorScheme: (scheme: ColorScheme) => void
}

export const DarkModeContext = createContext<DarkModeContextType | undefined>(undefined) 